import documentJson from './document.json';

const document = {
    ...documentJson
};

export default document;